import { createApp } from 'vue'
import { Lazyload } from 'vant'
import App from './App.vue'
import router from './router'
import store from './store'
import { createPinia } from 'pinia'
import { setupDirectives } from './plugins/directives'
import { setupMethods } from './plugins/middlewares'
import { setupMixins } from './plugins/mixins'
import { sentry } from './plugins/sentry'
import './assets/css/normalize.scss'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

const app = createApp(App)
setupDirectives(app)
setupMethods(app)
setupMixins(app)
app.use(sentry)
app.use(createPinia())
app.use(Lazyload, {
  lazyComponent: true
})
app.use(store).use(router).mount('#app')
